import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const BoxIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Box",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M16.45 12.88c-1.93 0-3.7 1.07-4.61 2.77a5.252 5.252 0 0 0-7.76-1.75V9.52c-.08-.57-.61-.98-1.18-.9-.47.07-.84.44-.9.91v8.67c.1 2.9 2.52 5.17 5.42 5.07a5.24 5.24 0 0 0 4.42-2.71 5.243 5.243 0 0 0 7.1 2.19 5.243 5.243 0 0 0 2.19-7.1 5.24 5.24 0 0 0-4.69-2.8m-9.2 8.39a3.15 3.15 0 0 1-3.19-3.1 3.15 3.15 0 0 1 3.1-3.19 3.15 3.15 0 0 1 3.19 3.1v.04c0 1.72-1.38 3.12-3.1 3.14m9.23 0a3.15 3.15 0 0 1-3.19-3.1c-.02-1.74 1.36-3.16 3.1-3.19s3.16 1.36 3.19 3.1v.04c0 1.73-1.39 3.14-3.12 3.14m13.33.36-2.84-3.5 2.84-3.5a1 1 0 0 0-.24-1.45 1.21 1.21 0 0 0-1.58.19l-2.45 3.01-2.44-3a1.21 1.21 0 0 0-1.58-.19 1 1 0 0 0-.29 1.38c.01.02.03.04.04.06l2.84 3.5-2.84 3.5a.987.987 0 0 0 .16 1.39c.02.02.05.04.08.05.5.34 1.17.26 1.58-.19l2.45-3 2.45 2.99c.4.45 1.08.53 1.58.19.46-.29.59-.9.29-1.35-.02-.03-.04-.05-.06-.08"
      })
    }) : /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M3.12 8C2.54 8 2.06 8.47 2 9.05v9.33c.06 2.97 2.45 5.36 5.43 5.36 2.1 0 3.9-1.17 4.78-2.92.93 1.69 2.74 2.92 4.78 2.92 2.97 0 5.43-2.45 5.43-5.43.06-3.03-2.4-5.48-5.37-5.48-2.1 0-3.91 1.17-4.78 2.92-.93-1.69-2.74-2.92-4.78-2.92-1.22 0-2.32.42-3.26 1.12v-4.9c0-.58-.46-1.05-1.1-1.05Zm25.64 4.8c-.28.03-.53.15-.7.39l-2.4 3.2-2.45-3.13c-.35-.47-1.04-.58-1.51-.18-.47.35-.6 1.04-.24 1.51l2.8 3.73-2.8 3.68c-.35.47-.22 1.16.24 1.51.47.35 1.16.29 1.51-.17l2.4-3.2 2.38 3.2c.35.47 1.06.58 1.52.17.52-.35.57-.98.28-1.51l-2.78-3.73 2.78-3.73c.35-.47.24-1.17-.23-1.52-.23-.18-.53-.24-.81-.21ZM7.43 14.98c1.81 0 3.26 1.47 3.26 3.27s-1.45 3.26-3.26 3.26-3.26-1.45-3.26-3.26 1.45-3.27 3.26-3.27m9.6 0c1.81 0 3.27 1.47 3.27 3.27s-1.47 3.26-3.27 3.26-3.26-1.45-3.26-3.26 1.45-3.27 3.26-3.27"
      })
    })
  }));
};